import externallinkicon1 from "Assets/images/externallinkicon/externallinkicon1.svg";
import externallinkicon2 from "Assets/images/externallinkicon/externallinkicon2.svg";
import externallinkicon3 from "Assets/images/externallinkicon/externallinkicon3.svg";
import externallinkicon4 from "Assets/images/externallinkicon/externallinkicon4.svg";
import externallinkicon5 from "Assets/images/externallinkicon/externallinkicon5.svg";


export default {
    externallinkicon1,
    externallinkicon2,
    externallinkicon3,
    externallinkicon4,
    externallinkicon5,
}